module.exports = __webpack_public_path__ + "static/nano.b966b1b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/covers/nano.jpg
// module id = 158
// module chunks = 35783957827783 41579278739242